import React from "react";

const Input = ({ id, type, label, bold, refProp, placeholder, fullWidth, preventPaste, value, setValue, disabled, errors, name, errorMessage }) => {

    const idProp = id ? { id } : {}
    const refPropObj = refProp ? { ref: refProp } : {}

    return (<div className="input-container" style={fullWidth ? { width: '100%' } : {}}>
        <label style={{ display: 'flex', marginTop: '15px', marginBottom: '5px', fontWeight: '500', fontSize: '16px', color: '#5E5E5E' }}>{label || ''}</label>
        <input {...idProp} {...refPropObj} onPaste={(e) => { preventPaste && e.preventDefault(); return false }} autoComplete="false" disabled={!!disabled} className={errors.map(({ name }) => name).includes(name) ? 'error' : ''} type={type} placeholder={placeholder || ''} value={value} onChange={(e) => setValue(e.target.value)} />
        {errorMessage && <p style={{ margin: 0, fontWeight: '500', fontSize: '15px', color: '#D90000' }}>{errorMessage}</p>}
    </div>)

}

export default Input